// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"7d376862","703":"ed506dc8"}[chunkId] + ".chunk.js";
};